import { useMemo } from "react";
import { useGetFeatureFlags } from "api/queries/common/useGetFeatureFlags";

// Returns false by default (fail-closed) until flags are available.
export default function useFeatureFlag(key: string): boolean {
  const { data: featureFlags } = useGetFeatureFlags();

  return useMemo(
    () => featureFlags?.some((featureFlag) => featureFlag.key === key && featureFlag.is_enabled) ?? false,
    [featureFlags, key],
  );
}
